@if (account()) {
  @let vm = account();

  <div
    class="card-view"
    [ngClass]="viewClasses()"
    [style.background-image]="
      accountType() !== AccountType.BankCard
        ? 'url(' + cardImageUrl() + ')'
        : ''
    "
    (click)="toggleFlip()"
    [@flipState]="flipState()"
  >
    @switch (accountType()) {
      @case (AccountType.FiatWallet) {
        <iw-fiat-wallet
          [wallet]="vm"
          [size]="size()"
          [iconSize]="iconSize"
          [currentWallet]="currentCard()"
          [useBalanceMask]="useBalanceMask()"
        />
      }

      @case (AccountType.CryptoWallet) {
        <iw-crypto-wallet
          [wallet]="vm"
          [size]="size()"
          [iconSize]="iconSize"
          [useBalanceMask]="useBalanceMask()"
        />
      }

      @case (AccountType.BankCard) {
        <iw-bank-card
          [account]="vm"
          [size]="size()"
          [iconSize]="iconSize"
          [menuShown]="!isMenuHidden()"
          [currentCard]="currentCard()"
          [useBalanceMask]="useBalanceMask()"
          [class]="'card-view-' + (size() ?? 'm')"
          [style.background-image]="'url(' + cardImageUrl() + ')'"
          (action)="action.emit($event)"
        />

        @if (flipEnabled()) {
          <iw-bank-card-back
            [class]="'card-view-' + (size() ?? 'm')"
            [sensitiveData]="sensitiveData()"
            [size]="size()"
            [actions]="actions()"
            [iconSize]="iconSize"
            [isLoading]="isLoading()"
            [(isSensitiveDataHidden)]="isSensitiveDataHidden"
          />
        }
      }

      @case (AccountType.TreasurerWallet) {
        <iw-treasurer-wallet
          [wallet]="vm"
          [size]="size()"
          [iconSize]="iconSize"
          [currentWallet]="currentCard()"
          [useBalanceMask]="useBalanceMask()"
        />
      }
    }

    @if (!isMenuHidden()) {
      <iw-button
        size="m"
        alignX="end"
        alignY="bottom"
        [onlyIcon]="true"
        uiType="secondary"
        class="wallet-menu-button"
        [inheritWidth]="false"
        (opened)="showOverlay()"
        iconName="dots-vertical"
        (click)="$event.stopPropagation()"
        [fuDropdownTriggerFor]="walletMenu"
      />
    }
  </div>

  <fu-dropdown #walletMenu>
    @if (opened() && actions()?.length) {
      <div class="wallet-menu-actions">
        @for (action of actions(); track action.label) {
          <iw-button
            uiType="custom"
            [disabled]="action.disabled && action.disabled()"
            (click)="action.callback(account())"
          >
            @if (action.iconName) {
              <fu-icon size="16" [iconName]="action.iconName"></fu-icon>
            }
            {{ action.label | translate }}
          </iw-button>
        }
      </div>
    }
  </fu-dropdown>
}
